import Environment from '../environment/Environment';
import { ObjToQueryString } from '../helpers/Helpers';

import { ISKULevelPlanningPayload } from '../interfaces/sku-level-sales-plan.interface';
import { getRequest, HandlerResponse, postFileUploadRequest, postRequest } from './api';
import { genearteNewToken } from './NewToken.api';

export const GetSKULevelSalesPlanData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/sku/getSKUGridData${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const InitializeSKU = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/sku/initialiseSKU${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const FreezePlan = async (payload: any, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/sku/freezePlan${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateData = async (payload: {rows: ISKULevelPlanningPayload[]}, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/sku/savePHData${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const CopyAspToPlan = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/sku/data/copyAsp${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const ImportTemplate = async (file, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postFileUploadRequest(`${Environment.API}/excel/sku/upload${queryString}`, file)
    .then((resp: any) => HandlerResponse(resp));
};

export const SaveSKULevelWeekData = async (payload: {rows: any[]}, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postRequest(`${Environment.API}/sku/save/weekEdit${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetSKULevelSalesPlanEditAllData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/sku/getSKUGridData/week${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};
